import { ApiResponse, http } from '@config/api';
import { Nullable } from '@utils/util.types';

export type RequestType = 'EXPRESS' | 'SEASONAL' | 'ONE_TIME';
export enum RequestTypeEnum {
	EXPRESS = 'EXPRESS',
	SEASONAL = 'SEASONAL',
	ONE_TIME = 'ONE_TIME',
}
export interface ExpressRequestInitialStep {
	specialist_id: string[];
	services_id: string[];
	request_type: RequestType;
	crop_id: string;
	area: number;
	unit: string;
	location_name: string;
	latitude: number;
	longitude: number;
	communication_language: string[];
	request_id?: Nullable<string>;
	connection_code?: string;
}

export interface SeasonalRequestInitialStep {
	specialist_id: string[];
	services_id: string[];
	request_type: RequestType;
	crop_id: string;
	area: number;
	unit: string;
	location_name: string;
	latitude: number;
	longitude: number;
	communication_language: string[];
	request_id?: Nullable<string>;
	start_date: Nullable<string>;
	end_date: Nullable<string>;
	connection_code?: string;
}

export async function getSpecialistByCropAndLanguage(
	cropId: string,
	languageId: string,
	monitoring: boolean = false
) {
	const response = await http.get(
		'users',
		`filter-by-crop-and-languages?crop_id=${cropId}&languages=${languageId}&monitoring=${monitoring}`
	);

	return response.data;
}

export async function getSpecialistByConnectionCode(code: string): Promise<any> {
	const response = await http.get('users', `find-by-connection-code?code=${code}`);

	return response.data;
}

export async function setInitialStep(specialistIds: string[], cropId: string, languages: string[]) {
	const response = await http.post('requests', 'initial-step', {
		specialistId: specialistIds,
		crop_id: cropId,
		language_id: languages,
	});

	return response.data;
}

export async function updateFarmSelection(requestId: string, farmId: string) {
	const response = await http.put('requests', `farm-selection/${requestId}`, {
		farm_id: farmId,
	});

	return response.data;
}

export async function updateFarmProblems(
	requestId: string,
	farmProblems: string,
	files?: string[]
) {
	console.log('Updating farm problems for requestId:', requestId);
	console.log('Problem description:', farmProblems);
	console.log('Files:', files);
	
	const response = await http.put('requests', `problem-description/${requestId}`, {
		problem_description: farmProblems,
		request_files: files, // Changed from 'files' to 'request_files' to match API expectations
	});
	
	console.log('updateFarmProblems response:', response.data);
	return response.data;
}

export async function submitInitialStep(request: ExpressRequestInitialStep | SeasonalRequestInitialStep) {
	console.log('Submitting initial step with request:', request);
	
	// Log date values specifically if they exist
	if ('start_date' in request && 'end_date' in request) {
		console.log('API request start_date:', request.start_date);
		console.log('API request end_date:', request.end_date);
	}
	
	const response = await http.post<ApiResponse<any>>('requests', 'step/initial-step', request);
	console.log('submitInitialStep response:', response.data);
	return response.data;
}

export async function getCurrentStepData(requestId: string) {
	console.log('Fetching current step data for requestId:', requestId);
	
	// Add a timestamp to prevent caching
	const timestamp = new Date().getTime();
	
	const response = await http.get<ApiResponse<any>>(
		'requests',
		`get-draft-record/${requestId || ''}?_t=${timestamp}`
	);
	
	console.log('getCurrentStepData response:', response.data);
	if (response.data && response.data.data) {
		console.log('Specialist IDs in response:', response.data.data.specialist_id);
		console.log('Connection code in response:', response.data.data.connection_code);
	}
	return response.data;
}

export async function submitFarmProblems(
	requestId: string,
	farmProblems: string,
	files?: string[]
) {
	const response = await http.post('requests', `step/problem-description/${requestId}`, {
		problem_description: farmProblems,
		request_files: files,
	});

	return response.data;
}

export async function completeRequest(requestId: string, isCompleted: boolean) {
	const response = await http.post<ApiResponse<any>>('requests', `complete-request/${requestId}`, {
		is_completed: isCompleted,
	});

	return response.data;
}

export async function getDraftExpressRequest() {
	const response = await http.get<ApiResponse<any>>('requests', 'draft');

	return response.data;
}

export async function deleteDraftExpressRequest(requestId: string) {
	const response = await http.delete<ApiResponse<any>>('requests', `delete-draft/${requestId}`);

	return response.data;
}

export async function getFilteredDrafts(requestId: string) {
	const response = await http.get<ApiResponse<any>>('requests', `filter-draft/${requestId}`);

	return response.data;
}
